import React, { useState, useEffect } from 'react';
import { db, storage } from '../firebase';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { useNavigate, useParams } from 'react-router-dom';
import { statesAndDistricts } from '../data/indianStates';

// SAME LIST AS ADD WORKER
const skillCategories = [
  "Electrician", "Plumber", "Carpenter", "Painter", 
  "Rajmistri (Mason)", "Labour", "Welder", "Tiles Mistry", 
  "Driver", "Mechanic", "Pop","Gardner",
  "Hotel Worker" , "Ac & Fridge Machenic", "WashingMachine Machenic", "WatchMan"  // ✅ Yahan bhi add kiya hai
];

const EditWorker = () => {
  const { id } = useParams(); // Worker ID URL se milegi
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [image, setImage] = useState(null);
  const [currentImageUrl, setCurrentImageUrl] = useState('');

  const [formData, setFormData] = useState({
    name: '', mobile: '', skills: [], experience: '', 
    state: '', district: '', village: '', wage: ''
  });

  const [availableDistricts, setAvailableDistricts] = useState([]);

  // ✅ 1. PURANA DATA LAO
  useEffect(() => {
    const fetchWorkerData = async () => {
      try {
        const docRef = doc(db, "workers", id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          setFormData({
            name: data.name || '',
            mobile: data.mobile || '',
            // Agar purana data string tha toh usse array banao, nahi toh array hi rakho
            skills: Array.isArray(data.skills) ? data.skills : (data.category ? [data.category] : []),
            experience: data.experience || '',
            state: data.state || '',
            district: data.district || '',
            village: data.village || '',
            wage: data.wage || ''
          });
          setCurrentImageUrl(data.imageUrl || '');
          
          if (data.state) {
            setAvailableDistricts(statesAndDistricts[data.state] || []);
          }
        } else {
          alert("Worker not found!");
          navigate('/profile');
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setLoading(false);
    };

    fetchWorkerData();
  }, [id, navigate]);

  // --- HANDLERS ---
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (name === 'state') setAvailableDistricts(statesAndDistricts[value] || []);
  };

  const toggleSkill = (skill) => {
    let newSkills = [...formData.skills];
    if (newSkills.includes(skill)) {
      newSkills = newSkills.filter(s => s !== skill);
    } else {
      newSkills.push(skill);
    }
    setFormData({ ...formData, skills: newSkills });
  };

  const handleImageChange = (e) => {
    if (e.target.files[0]) setImage(e.target.files[0]);
  };

  // ✅ 2. DATA UPDATE KARO
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (formData.skills.length === 0) return alert("Select at least one skill.");
    
    setUpdating(true);
    try {
      let imageUrl = currentImageUrl; // Default: Purani photo rakho

      // Agar nayi photo select ki hai toh upload karo
      if (image) {
        const imageRef = ref(storage, `workers/${Date.now()}_${image.name}`);
        await uploadBytes(imageRef, image);
        imageUrl = await getDownloadURL(imageRef);
      }

      const docRef = doc(db, "workers", id);
      await updateDoc(docRef, {
        ...formData,
        imageUrl,
        updatedAt: new Date()
      });

      alert("Worker Details Updated Successfully!");
      navigate('/profile');
    } catch (error) {
      console.error("Error updating:", error);
      alert("Error updating profile.");
    }
    setUpdating(false);
  };

  if (loading) return <div className="text-center mt-20">Loading data...</div>;

  return (
    <div className="min-h-screen bg-slate-50 p-6 flex justify-center">
      <div className="w-full max-w-2xl bg-white rounded-3xl shadow-xl p-8">
        <h2 className="text-3xl font-extrabold text-slate-800 mb-6">✏️ Edit Worker Profile</h2>

        <form onSubmit={handleUpdate} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input name="name" value={formData.name} placeholder="Worker Name" onChange={handleChange} className="p-4 rounded-xl bg-slate-50 border border-slate-200 outline-none" required />
            <input name="mobile" value={formData.mobile} type="number" placeholder="Mobile" onChange={handleChange} className="p-4 rounded-xl bg-slate-50 border border-slate-200 outline-none" required />
          </div>

          <div>
            <label className="block text-sm font-bold text-slate-500 mb-2">Experience (Years)</label>
            <input name="experience" value={formData.experience} type="number" onChange={handleChange} className="w-full p-4 rounded-xl bg-slate-50 border border-slate-200 outline-none" required />
          </div>

          <div>
            <label className="block text-sm font-bold text-slate-500 mb-2">Select Skills</label>
            <div className="flex flex-wrap gap-2">
              {skillCategories.map(skill => (
                <button
                  key={skill}
                  type="button"
                  onClick={() => toggleSkill(skill)}
                  className={`px-4 py-2 rounded-full text-sm font-bold border transition-all ${
                    formData.skills.includes(skill) 
                    ? 'bg-blue-600 text-white border-blue-600' 
                    : 'bg-white text-slate-600 border-slate-200'
                  }`}
                >
                  {formData.skills.includes(skill) ? '✓ ' : '+ '} {skill}
                </button>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <select name="state" value={formData.state} onChange={handleChange} className="p-4 rounded-xl bg-slate-50 border border-slate-200 outline-none" required>
              <option value="">State</option>
              {Object.keys(statesAndDistricts).map(s => <option key={s} value={s}>{s}</option>)}
            </select>
            <select name="district" value={formData.district} onChange={handleChange} className="p-4 rounded-xl bg-slate-50 border border-slate-200 outline-none" required>
              <option value="">District</option>
              {availableDistricts.map(d => <option key={d} value={d}>{d}</option>)}
            </select>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input name="village" value={formData.village} placeholder="Village" onChange={handleChange} className="p-4 rounded-xl bg-slate-50 border border-slate-200 outline-none" required />
            <input name="wage" value={formData.wage} type="number" placeholder="Daily Wage" onChange={handleChange} className="p-4 rounded-xl bg-slate-50 border border-slate-200 outline-none" required />
          </div>

          <div>
            <label className="block text-sm font-bold text-slate-500 mb-2">Worker Photo</label>
            <div className="flex items-center gap-4 mb-2">
                {currentImageUrl && <img src={currentImageUrl} alt="Current" className="w-16 h-16 rounded-xl object-cover border" />}
                <span className="text-xs text-slate-400">Current Photo</span>
            </div>
            <input type="file" onChange={handleImageChange} className="w-full p-3 bg-slate-50 rounded-xl border border-slate-200" />
          </div>

          <button disabled={updating} className="w-full bg-blue-600 text-white py-4 rounded-xl font-bold text-lg hover:bg-blue-700 shadow-lg">
            {updating ? 'Updating...' : '💾 Update Profile'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditWorker;